import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var signupotpRes;
export const signupotpTodo = createAsyncThunk('signupOtpVerify', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'signup_otp_verify',
            data: {
                "email": data?.email,
                "otp": data?.otp
            },
            headers: { "Content-Type": "application/json" }
        })
        return signupotpRes = res

    } catch (error) {
        return signupotpRes = error.response
    }
})